import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import DatePicker from "react-datepicker";
import ReactToPdf from "react-to-pdf";
import logo from "./images/loading.gif";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css';
import '../scss/green-theme.css';
import ModalLogin from './ModalLogin';
//import Mymodal from './modal';
//import config from '../config';
import Cookies from "universal-cookie";
import logonorecord from "./images/recordnotfound.png";
const axios = require("axios");
const ref = React.createRef();
const cookies = new Cookies();
export default class AdminFuelMonthWise extends Component{
  constructor(props)
  {
    super(props);
    this.state=
    { input:{},
      myitems:[],
      isLoaded: false,
      islocation:false,
      isData: false,
      fromDate: new Date(),
      toDate: new Date(),
      ErrMsg:"",
      FuellDiff:0,
      MileageDiff:0,
      TotalMileage:0,
      divonoff:"none",
      VehID:"",
      Vehuser:"",
      Vehmake:"",
      Vehmodel:"",
      Vehtype:"",
      Vehlocation:"",
      Vehfueltype:"",
      cmonth:"",
      Prevreading:0,
      

      
      fdate: Moment(new Date()).format("DD/MM/YYYY"),
      tdate: Moment(new Date()).format("DD/MM/YYYY")

    };
    this.handlechangefrom = this.handlechangefrom.bind(this);
    this.handlechangeto = this.handlechangeto.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange=this.handleInputChange.bind(this);
    this.handleFocus=this.handleFocus.bind(this);
  //  this.rendercontent = this.rendercontent.bind(this);

  }
    handleInputChange = (e)=> {
        this.setState({VehID: e.target.value,divxls:"none",myitems:[]});
    }
    handleFocus(event){event.target.select();}

  cur(num) 
  {
    
    let cnum=parseFloat(num,2);
    if(cnum > 0)
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
  }
  cur2(num) 
  {
//    let cnum=parseInt(num,2);
    if(num > 0)
        return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
  }
  componentDidMount()
  {
  //  let input = this.state.input;
//    if(cookies.get("LoginID"))
//    { input["ID"]=cookies.get("LoginID");
//      this.setState({ErrMsg:"",islocation:true,isLoaded:true,myitems:[]});
//    }
//    else
//    { this.setState({ErrMsg:<ModalLogin/>});}
  }
  handlechangefrom(date)
  {
    this.setState({fdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({fromDate: date});
  }
  handlechangeto(date)
  {
    this.setState({tdate:Moment(date).format("DD/MM/YYYY")});
    this.setState({toDate:date});
  }
  handleSubmit()
    {
      let fdate=new Date(this.state.fromDate);
      let preading=0;
      let fyear=fdate.getFullYear();
      let fmonth=fdate.getMonth()+1;
      document.body.style.cursor="wait";
      this.setState({ErrMsg:<img src={logo} alt=""/>,divonoff:"none"});
      let input=this.state.input;
      input["DateFrom"]=this.state.fromDate;
      input["DateTo"]=this.state.toDate;
      input["VehID"]=this.state.VehID

      this.setState({input});
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/userv/fuelmonthwise/',
          data: this.state.input,
          headers: {'Content-Type': 'multipart/form-data'}
      })
      .then((response)=> {
        document.body.style.cursor="default";
        console.log(response.data);
        if(response.data==0)
          this.setState({ErrMsg:<img style={{paddingTop:50}} src={logonorecord} alt=""/>,divonoff:"none"});
        else
          if(fmonth < response.data[0]["emonth"] || fyear < response.data[0]["eyear"])
             preading=response.data[0]["rurr_reading"]; 
          else
              preading=0;

          this.setState({
              isLoaded: true,
              islocation:true,
              ErrMsg:"",
              divonoff:"block",
              Vehuser:response.data[0]["Name"],
              Userdesignation:response.data[0]["Designation"],
              Vehlocation:response.data[0]["Location"],
              Vehmake:response.data[0]["Veh_Make"],
              Vehmodel:response.data[0]["Veh_Model"],
              Vehtype:response.data[0]["Veh_Type"],
              Vehfueltype:response.data[0]["Fuel_Type"],
              Prevreading:preading,
              myitems: response.data
          });
      })
      .catch((response)=> {
        document.body.style.cursor="default";
        this.setState({ErrMsg:<img src={logonorecord} alt=""/>,divonoff:"none"});
      })
    }
  
    render()
    {
      let fileName=this.state.VehID+"-fuelMonthWise.pdf";
      let items = this.state.myitems;
      let TotalMileage=0;
      let TotalFuel=0;
      let mileage1=0;
      let totalitems=this.state.myitems.length;
      let preading=0;

      return(

        <div marginTop="20px">
          <br></br>
          <div width="100%"  >
          <div className='inner-profile'>
          <span className="box-title">Fuel Expenses</span>
          <div className="inner-profile2" >
            <label style={{paddingLeft:2,paddingBottom:2,width:"100px"}} >Vehicle#:</label>
                <input style={{paddingBottom:2,width:100}}
                    autoFocus="autofocus"
                    name="VehID"
		        	placeholder="Vehicle number"
                    onChange={this.handleInputChange}
                    onFocus={ this.handleFocus}
            />
        <br></br>        
          <label style={{paddingLeft:2,width:"100px",marginTop:"5px"}}>From: </label>
              <DatePicker                          
                selected={this.state.fromDate}
                value = {this.state.fromDate}
                onChange={this.handlechangefrom}
                name="fromDate"
                dateFormat="dd/MM/yyyy" className="form_control"/>
          <br></br>
          <label style={{paddingLeft:2,width:"100px",marginTop:"5px"}} >To:</label>
              <DatePicker
                selected={ this.state.toDate }
                value = {this.state.toDate}
                onChange={this.handlechangeto}
                name="toDate"
                dateFormat="dd/MM/yyyy" className="form_control"/>
            <button onClick={this.handleSubmit} style={{marginLeft:"50px"}}>Submit</button>
        </div>
        <br></br><br></br>
          <div style={{width:"100%",textAlign:"center",display:this.state.divonoff,backgroundColor:'white'}} ref={ref} >
              <table style={{width:"100%"}} >
                  <thead>
                  <tr>
                    <th className="thmf" scope="col">Vehicle Registration#</th>
                    <th className="thmf2" scope="col">{this.state.VehID}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Vehicle Make</th>
                    <th className="thmf2" scope="col">{this.state.Vehmake}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Vehicle Model</th>
                    <th className="thmf2" scope="col">{this.state.Vehmodel}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Vehicle Type</th>
                    <th className="thmf2" scope="col">{this.state.Vehtype}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Fuel Type</th>
                    <th className="thmf2" scope="col">{this.state.Vehfueltype}</th>
                  </tr>

                  <tr>
                    <th className="thmf" scope="col">User Name</th>
                    <th className="thmf2" scope="col">{this.state.Vehuser}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Designation</th>
                    <th className="thmf2" scope="col">{this.state.Userdesignation}</th>
                  </tr>
                  <tr>
                    <th className="thmf" scope="col">Location</th>
                    <th className="thmf2" scope="col">{this.state.Vehlocation}</th>
                  </tr>
                  </thead>
                  <tbody></tbody>
                  </table>
                  <table style={{width:"100%",marginTop:"5px"}} >
                  <thead>


                  <tr className="tr">
                    <th className="thm"  colSpan={2} >Month, Year</th>
                    <th className="thm" >Payment Mode</th>
                    <th className="thm" >Previous Reading (KM)</th>
                    <th className="thm" >Current Reading (KM)</th>
                    <th className="thm" >Mileage (KM)</th>
                    <th className="thm" >Quantity (Ltr/Kg)</th>
                    <th className="thm" >Average Ltr/KM</th>

                    <th className="thm" >Amount</th>
                  </tr>
                  </thead>
                  <tbody>

                            {items.map((result ,i) => {

/*                                  TotalFuel = TotalFuel + Number(result.Fuel_Qty)
                                  if(i === 0)
                                  {
                                    mileage1= result.Veh_Curr_Mreading;
                                  }
                                  if(i === totalitems - 1)
                                  {
                                    TotalMileage= result.Veh_Curr_Mreading-mileage1;
                                    TotalFuel = TotalFuel - Number(result.Fuel_Qty);
                                  }*/
                                if( i > 0)
                                {
                                  preading=this.state.myitems[i-1]["curr_reading"];
                                  mileage1=(result.curr_reading-this.state.myitems[i-1]["curr_reading"])/result.Qty;
                                  TotalMileage=result.curr_reading-this.state.myitems[i-1]["curr_reading"];
                                }
                             
                                return (
                                  <tr className="trc" key={i}>
                                    <td className="td" colSpan={2}>{result.cmonth+", "+ result.eyear}</td>
                                    <td className="td" >{result.Payment_Mode}</td>
                                    <td className="td" >{preading}</td>
                                    <td className="td" >{result.curr_reading}</td>
                                    <td className="td" >{TotalMileage}</td>
                                    <td className="td" >{this.cur(result.Qty)}</td>
                                    <td className="td" >{this.cur(mileage1)}</td>
                                    <td className="td" >{this.cur(result.Amount)}</td>                                    
                                  </tr>
                            )                                   

                        })}
                          </tbody>
                        </table>
{/*}                        <h6>
                        <div >Fuel average = {this.cur2(TotalMileage/TotalFuel)} KM/Ltr.</div>
                        </h6>*/}
                        <br></br>
                        <div align="center" width="650px" paddingTop="50px">
                          <ReactToPdf targetRef={ref} filename={fileName} x={8} y={1}>
                          {({toPdf}) => (
                          <button onClick={toPdf} style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                          )}
                          </ReactToPdf>
                      </div>

                  </div>
            <br></br>

          </div>

         </div>
         <div style={{textAlign:"center",width:"80%"}}>{this.state.ErrMsg}</div>

          </div>
        );
  }
}

